import { Component, ChangeDetectionStrategy } from "@angular/core";
import { AppsService } from "src/app/shared/services/apps.service";
import { ThemeConstantService } from "src/app/shared/services/theme-constant.service";
import { ActivatedRouteSnapshot, NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs/operators";
import { UserService } from "./providers/user/user.serivce";
import { CstmSocketIOService } from "./providers/socket-io.service";
import { HttpClient } from "@angular/common/http";
import { NzNotificationService } from "ng-zorro-antd/notification";
import { TransfereService } from "./providers/transfer/transfer.service";
import { SessionTimeoutService } from "./shared/services/session-timeout.service";
// import { VehicleMonitoringService } from './providers/vehicle-monitoring.service';
// import { PushNotificationsService } from './providers/push-notifications.service';

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppComponent {
  selectedHeaderColor: string;
  empdata: any;
  isFolded: boolean;
  isSideNavDark: boolean;
  isExpand: boolean;
  url: string;
  full_screen: boolean;
  clntDtls: any;
  usrDtls;
  socketId;
  interval: any;
  vehicleData: any;
  allRcvdData = [];
  constructor(
    private router: Router,
    public userService: UserService,
    public apiSrv: AppsService,
    private themeService: ThemeConstantService,
    private socketService: CstmSocketIOService,
    private http: HttpClient,
    // private notificationService: PushNotificationsService,
    private notification: NzNotificationService,
    public TransfereService: TransfereService,
    private sessionTimeout: SessionTimeoutService
  ) {
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.clntDtls = JSON.parse(localStorage.getItem("wto_clients"));
    this.usrDtls = JSON.parse(localStorage.getItem("wto_w_user"));
    // Arm the idle/absolute session timeout if a session already exists
    // (e.g. on a hard page refresh while logged in).
    if (this.usrDtls && this.usrDtls.usr_id) {
      this.sessionTimeout.start();
    }
  }
  ngOnInit(): void {
    this.userService.userLoggedIn.subscribe((event: any) => {
      console.log(event);
      if (event == true) {
        this.clntDtls = JSON.parse(localStorage.getItem("wto_clients"));
        this.usrDtls = JSON.parse(localStorage.getItem("wto_w_user"));
        // (Re)start session timeout monitoring on successful login.
        this.sessionTimeout.start();

        console.log(this.socketId, "ssssssssssssssssssssss");

        if (this.usrDtls.rle_id == 3000005) {
          // if (Notification.permission === 'default') {
          //     Notification.requestPermission().then((permission) => {
          //         if (permission === 'granted') {
          //             console.log('Push notifications enabled');
          //         }
          //     });
          // }
          // this.notificationService.requestPermission();
          // this.notificationService.showNotification();
          // this.http.get(`/alerts/veh/notifications/${this.socketId}`).subscribe(response => {
          // console.log('Notifications:', response);
          this.socketService.initSocketIOCnct();
          // this.socketId = this.socketService.getSocketIOSessionID();
          this.socketService.getSocketIOSessionID().subscribe((socketId) => {
            this.socketId = socketId;
            console.log("Retrieved Socket ID:", this.socketId);
          });
          this.saveScktIdToUser();
          this.listenToSocketNotifs();

          // });
        }
      } else {
        this.clntDtls = null;
        this.usrDtls = null;
        // Stop monitoring on logout so timers/listeners are released.
        this.sessionTimeout.stop();
      }
    });
    this.url = this.router.url;

    // Drive the chrome off the ROUTE, not off a flag someone has to remember to
    // clear. <app-header> and <app-sidenav> used to be gated on `clntDtls`
    // alone, which is set by userService.loggedIn(true) and cleared by
    // loggedIn(false) — and the paths that end a session do not all call it:
    //   - login.ts fires loggedIn(true) BEFORE the router has left /internal, so
    //     the logged-in header and side-nav painted around the still-mounted
    //     login form. That half-and-half screen is what a "stuck" login looked
    //     like until the dashboard replaced it a beat later.
    //   - SessionTimeoutService.expire() and MenuScopeGuard.forceLogout() clear
    //     localStorage and navigate to /internal without calling loggedIn(false),
    //     so the same chrome stayed up over the login page after a timeout.
    // The auth route already declares data: { full_screen: true } (app-routing),
    // which nothing was reading. Reading it fixes every one of those paths at
    // once, because the router is the thing that is actually always right about
    // which screen is on display.
    this.full_screen = this.isFullScreenRoute();
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe(() => (this.full_screen = this.isFullScreenRoute()));

    this.themeService.isMenuFoldedChanges.subscribe(
      (isFolded) => (this.isFolded = isFolded)
    );
    this.themeService.isSideNavDarkChanges.subscribe(
      (isDark) => (this.isSideNavDark = isDark)
    );
    this.themeService.selectedHeaderColor.subscribe(
      (color) => (this.selectedHeaderColor = color)
    );
    this.themeService.isExpandChanges.subscribe(
      (isExpand) => (this.isExpand = isExpand)
    );

    // if (this.usrDtls.rle_id == 3000005) {
    //     if (Notification.permission === 'default') {
    //         Notification.requestPermission().then((permission) => {
    //             if (permission === 'granted') {
    //                 console.log('Push notifications enabled');
    //             }
    //         });
    //     }
    //     setInterval(() => {
    //         this.vehicleMonitorService.fetchVehicleData();
    //     }, 60000);
    // }
  }
  /**
   * Is the router currently on a route that asked to own the whole viewport?
   *
   * Walks the activated chain rather than testing `data['full_screen']` on one
   * snapshot, so it does not depend on how route data inherits down to the lazy
   * child that actually carries the component. Today the only such route is
   * `internal` (the login screen) in app-routing.module.ts.
   */
  private isFullScreenRoute(): boolean {
    let r: ActivatedRouteSnapshot = this.router.routerState.snapshot.root;
    while (r) {
      if (r.data && r.data["full_screen"] === true) {
        return true;
      }
      r = r.firstChild;
    }
    return false;
  }

  listenToSocketNotifs() {
    this.socketService.listenForNotifications().subscribe((msg: any) => {
      // console.log('Socket Notification:', msg);
      this.vehicleData = msg.msg;
      // if (this.vehicleData.length > 0) {
      // console.log(this.vehicleData);

      this.vehicleData.forEach((vehicle: any) => {
        // this.interval = setInterval(() => {
        this.shwNotifications(vehicle);
        // }, 600);
      });
      // this.allRcvdData.push(this.vehicleData)
      // }
    });
  }
  shwNotifications(vehicle) {
    // Check if user is logged in and session is valid before showing notifications

    // Don't show notifications if user is logged out or session expired
    if (!this.usrDtls) {
      console.log(
        "User logged out or session expired - notification suppressed"
      );
      return;
    }

    // Only show notifications if user is logged in and has valid session
    this.notification
      .blank(
        "",
        `<div class="ntfctn">
            <div >
               <img src="/assets/images/logo/icon.png" >            
            </div>
            <div >
              <div class="ntfctn_title">Vehicle Stoppage Notification </div>
                ${vehicle.alert_tx}           
            </div>
        </div>
        `,
        {
          nzDuration: 20000,
          nzStyle: {
            boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
            padding: "10px",
            margin: "10px",
            nzCloseIcon: true,
            color: "black",
          },
        }
      )
      .onClick.subscribe(() => {
        // clearInterval(this.interval);
        //     this.TransfereService.setLoclData('vehData', this.vehicleData)
        //     this.router.navigate(['/internal/notifications/list']);
      });
  }
  saveScktIdToUser() {
    console.log(this.socketId);
    if (this.socketId != undefined) {
      this.http
        .post("/alerts/user/save-socket-id", { sckt_id: this.socketId })
        .subscribe((response) => {
          console.log("Socket ID saved:", response);
        });
    }
  }
}
